import { Text } from '@chakra-ui/react';

export const TextContainer = ({ className, ...props }) => {
  return (
    <Text
      component={'div'}
      sx={{
        '& > *': {
          marginTop: 0,
          marginBottom: 0,
        },
        '& > * + *': {
          marginTop: '1em',
        },
      }}
      className={className}
      {...props}
    />
  );
};
